
import Home from '../Home'
import FacebookButton from './components/FacebookButton'
import styles from './singup.module.css'
export default function Singup({ setSex, userSex, setLogin, userisloged }) {
  const submitForm = (e) => {
    e.preventDefault()
    setLogin(true)
  }
  return (
    <>
      {
        userisloged ? (
          <Home />
        ) : (
          <div className={styles.main_conteiner}>
            <form className={styles.register} onSubmit={submitForm}>
              <div className={styles.preview}>
                <img src={`./${userSex}.png`} alt='user preview' />
              </div>
              <div className={styles.usernames}>
                <input type='text' placeholder='Nome de usuário' required />
                <input type='email' placeholder='E-mail' required />
              </div>
              <div className={styles.second_group}>

                <input type='password' placeholder='Senha' required />
                <div className={styles.genders}>
                  <span>Sexo: </span>
                  <input type='radio' name='gender' required value='ele' id='male'
                    onChange={
                      (e) => setSex(e.target.value)
                    } />
                  <label htmlFor='male'>Masculino</label>
                  <input type='radio' name='gender' required value='ela' id='female' onChange={
                    (e) => setSex(e.target.value)
                  } />
                  <label htmlFor='female'>Feminino</label>
                </div>
              </div>
              <input type='submit' value='Criar conta' />
              <h2>Ou</h2>
              <FacebookButton />
            </form>

          </div>
        )
      }
    </>
  )
}